import { render, staticRenderFns } from "./RoleManagementDetailUpload.vue?vue&type=template&id=287ebb21&"
import script from "./RoleManagementDetailUpload.vue?vue&type=script&lang=js&"
export * from "./RoleManagementDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports